import { Module } from 'vuex';
import { RootState } from '../../types';
import { SystemSettingsState } from './types';
import { getters } from './getters';
import { actions } from './actions';
import { mutations } from './mutations';

export const state: SystemSettingsState = {
  systemSettings: [],
};

export const systemSettings: Module<SystemSettingsState, RootState> = {
  state,
  getters,
  actions,
  mutations
};